// import ForgotPage from '@/views/forgot/Forgot.vue';
// import SendEmailPage from '@/views/forgot/SendEmail.vue';
// import NewPasswordPage from '@/views/forgot/NewPassword.vue';
// import PasswordSuccessPage from '@/views/forgot/PasswordSuccess.vue';
// import Index from '@/views/NotSidebar.vue';
const ForgotPage = () => import('@/views/forgot/Forgot.vue');
const SendEmailPage = () => import('@/views/forgot/SendEmail.vue');
const NewPasswordPage = () => import('@/views/forgot/NewPassword.vue');
const PasswordSuccessPage = () => import('@/views/forgot/PasswordSuccess.vue');
const Index = () => import('@/views/NotSidebar.vue');

import getWhiteLabel from '@/utils/getWhiteLabel';

const forgotRouter = {
    path: '/forgot',
    component: Index,
    name: 'forgot',
    meta: {
        requiresAuth: false
    },
    children: [{
            name: 'forgot',
            path: '/',
            component: ForgotPage,
            meta: {
                title: `${getWhiteLabel()} - Recuperação de senha`,
                requiresAuth: false
            },
        },
        {
            name: 'sucessForgot',
            path: 'success',
            component: SendEmailPage,
            meta: {
                title: `${getWhiteLabel()} - Recuperação de senha`,
                requiresAuth: false
            },
        },
        {
            name: 'sucessForgot',
            path: 'password/success',
            component: PasswordSuccessPage,
            meta: {
                title: `${getWhiteLabel()} - Recuperação de senha`,
                requiresAuth: false
            },
        },
        {
            name: 'sucessForgot',
            path: 'password/:token',
            component: NewPasswordPage,
            meta: {
                title: `${getWhiteLabel()} - Recuperação de senha`,
                requiresAuth: false
            },
        },
    ]


}

export default forgotRouter;